module.exports = __webpack_public_path__ + "static/image/history/pc/201812@3x.jpg?5af44a4c";